import axios from 'axios'
import Vue from 'vue'

import {
    Loading,
    Message
} from 'element-ui';

let loading //定义loading变量

let baseURL = "" // 接口域名
// let baseURL = "https://gjgx.dc-it.cn/api/" // 打包时打开这个路径
if (process.env.VUE_APP_MODE === 'development') {
    //开发环境下的执行操作
    baseURL = process.env.VUE_APP_API_URL
} else if (process.env.VUE_APP_MODE === 'test') {
    //测试环境下的执行操作
    baseURL = process.env.VUE_APP_API_URL
} else {
    //生产环境下的执行操作
    baseURL = process.env.VUE_APP_API_URL
}

function startLoading() { //使用Element loading-start 方法
    loading = Loading.service({
        lock: false,
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.0)'

    })
}

function endLoading() { //使用Element loading-close 方法
    loading.close()
}

//创建单例
const distance = axios.create({
    baseURL: baseURL,
    timeout: 5000, // 请求超时时间
})

// 请求拦截
distance.interceptors.request.use(config => {
    startLoading() // 加载
    let webUserInfo = JSON.parse(localStorage.getItem('webUserInfo'))
    if(webUserInfo){
        config.headers.token = webUserInfo.token;
        config.headers.id = webUserInfo.id;
    }
    return config;
}, err => {
    return Promise.reject(err)
})

// 相应拦截 401 token过期
distance.interceptors.response.use(response => {
    //关闭加载
    endLoading()
    return response;
}, err => {
    //报错关闭加载动画
    endLoading();
    // console.log(err.response, "111111111");
    // 截取报错
    if (err.response) {
        // 判断用户输入的账号密码是否符合设计要求
        // let errCode = err.response.data.error_code;
        // if (errCode == 30001 || errCode == 10000 || errCode == 30002 || errCode == 30003) {
        //     Message.error(err.response.data.msg);
        // }
        Message.error(err.response.data.msg);
        // 判断手机是否注册
        // if(errCode == 900){
        //     Message.error(err.response.data.msg);
        // }
    }
    return Promise.reject(err)
})
// 添加全局的$http方法
Vue.prototype.$http = distance; //axios
// export default distance;